import styled from 'styled-components';
import { colors, grid, fonts } from '_/styles';

export const Wrapper = styled.div`
  margin-bottom: ${grid.medium};
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ separator }) => {
    if (separator === 'top') {
      return `border-top: 1px solid ${colors.divider};
              padding-top: ${grid.medium};`;
    }

    if (separator === 'bottom') {
      return `border-bottom: 1px solid ${colors.divider};
              padding-bottom: ${grid.medium};`;
    }

    return (
      separator &&
      `border-top: 1px solid ${colors.divider};
                         border-bottom: 1px solid ${colors.divider};
                         padding: ${grid.medium} 0;`
    );
  }}
`;

export const Label = styled.span`
  display: block;
  color: ${colors.textOption};
  font-size: ${fonts.size.default};
`;

export const Value = styled.span`
  display: block;
  color: ${colors.textMain};
  font-size: ${fonts.size.medium};
`;
